import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import {
    GET_NO_APPOINTMENT_CHART,
    GET_CLINIC_APPOINTMENT_RATE,
    GET_PREEMPLOYMENT_RATE,
    GET_NO_PATIENT_RATE,
    GET_TELECONSULT_RATE,
    GET_ATTACHMENT,
    GET_EXPORT_CLINIC_APPOINTMENT,
    GET_EXPORT_PREEMPLOYMENT,
    GET_EXPORT_TELECONSULTATION,
    GET_EXPORT_PATIENT,
    GET_EXPORT_ADMIN,
} from "./actionTypes.js";

import {
    getNoofAppointmentChartSuccess,
    getNoofAppointmentChartFail,
    getClinicAppointmentRateSuccess,
    getClinicAppointmentRateFail,
    getPreemploymentRateSuccess,
    getPreemploymentRateFail,
    getNoPatientRateSuccess,
    getNoPatientRateFail,
    getTelecosultRateSuccess,
    getTelecosultRateFail,
    getAttachmentSuccess,
    getAttachmentFail,
    getExportClinicAppointmentSuccess,
    getExportClinicAppointmentFail,
    getExportPreemploymentSuccess,
    getExportPreemploymentFail,
    getExportTeleconsultationSuccess,
    getExportTeleconsultationFail,
    getExportPatientSuccess,
    getExportPatientFail,
    getExportAdminSuccess,
    getExportAdminFail,
} from "./action.js"

import { noOFAppoinetmentChartApi, clinicAppointmentRate, preemploymentRate, noPatientRate, attachementAPI, teleconsultationRate, exportClinicAppointment, exportPreemployment, exportTeleconsultstion, exportPatient, exportAdmin } from "./dashboardApi.js";
function* fetchNoofAppointment() {
    try {
        const response = yield call(noOFAppoinetmentChartApi)
        yield put(getNoofAppointmentChartSuccess(response))
    } catch (error) {
        yield put(getNoofAppointmentChartFail(error))
    }
}

function* fetchClinicAppointmentRate() {
    try {
        const response = yield call(clinicAppointmentRate)
        yield put(getClinicAppointmentRateSuccess(response))
    } catch (error) {
        yield put(getClinicAppointmentRateFail(error))
    }
}

function* fetchPreemploymentRate() {
    try {
        const response = yield call(preemploymentRate)
        yield put(getPreemploymentRateSuccess(response))
    } catch (error) {
        yield put(getPreemploymentRateFail(error))
    }
}

function* fetchNoPatientRate() {
    try {
        const response = yield call(noPatientRate)
        yield put(getNoPatientRateSuccess(response))
    } catch (error) {
        yield put(getNoPatientRateFail(error))
    }
}

function* fetchTeleconsultationRate() {
    try {
        const response = yield call(teleconsultationRate)
        yield put(getTelecosultRateSuccess(response))
    } catch (error) {
        yield put(getTelecosultRateFail(error))
    }
}

function* fetchAttachment({ payload: attachment }) {
    try {
        const response = yield call(attachementAPI, attachment)
        yield put(getAttachmentSuccess(response))
    } catch (error) {
        yield put(getAttachmentFail(error))
    }
}

function* fetchExportClinicAppointment({ payload: appointment }) {
    try {
        const response = yield call(exportClinicAppointment, appointment)
        yield put(getExportClinicAppointmentSuccess(response))
    } catch (error) {
        yield put(getExportClinicAppointmentFail(error))
    }
}

function* fetchExportPreemployment({ payload: appointment }) {
    try {
        const response = yield call(exportPreemployment, appointment)
        yield put(getExportPreemploymentSuccess(response))
    } catch (error) {
        yield put(getExportPreemploymentFail(error))
    }
}

function* fetchTeleconsultation({ payload: appointment }) {
    try {
        const response = yield call(exportTeleconsultstion, appointment)
        yield put(getExportTeleconsultationSuccess(response))
    } catch (error) {
        yield put(getExportTeleconsultationFail(error))
    }
}

function* fetchPatient({ payload: patient }) {
    try {
        const response = yield call(exportPatient, patient)
        yield put(getExportPatientSuccess(response))
    } catch (error) {
        yield put(getExportPatientFail(error))
    }
}

function* fetchExportAdmin({ payload: admin }) {
    try {
        const response = yield call(exportAdmin, admin)
        yield put(getExportAdminSuccess(response))
    } catch (error) {
        yield put(getExportAdminFail(error))
    }
}

function* DashboardSaga() {
    yield takeEvery(GET_NO_APPOINTMENT_CHART, fetchNoofAppointment)
    yield takeEvery(GET_CLINIC_APPOINTMENT_RATE, fetchClinicAppointmentRate)
    yield takeEvery(GET_PREEMPLOYMENT_RATE, fetchPreemploymentRate)
    yield takeEvery(GET_NO_PATIENT_RATE, fetchNoPatientRate)
    yield takeEvery(GET_TELECONSULT_RATE, fetchTeleconsultationRate)
    yield takeEvery(GET_ATTACHMENT, fetchAttachment)
    yield takeEvery(GET_EXPORT_CLINIC_APPOINTMENT, fetchExportClinicAppointment)
    yield takeEvery(GET_EXPORT_PREEMPLOYMENT, fetchExportPreemployment)
    yield takeEvery(GET_EXPORT_TELECONSULTATION, fetchTeleconsultation)
    yield takeEvery(GET_EXPORT_PATIENT, fetchPatient)
    yield takeEvery(GET_EXPORT_ADMIN, fetchExportAdmin)

}

export default DashboardSaga
